import React, {useMemo} from "react";
import {useIntl} from "react-intl";
import PageWrapper from "../../../component/home/HomeContentPage";
import KoFAQConsole from "../../../assets/images/home/faq_console_ko.jpeg";
import FAQCloseupShadow from "../../../assets/svgs/home/closeup_shadow.svg";
import KoFAQSetting from "../../../assets/images/home/faq_setting_ko.png";
import * as Page from "../../../component/home/HomeContentPage";

const FAQInfoPage: React.FC = () => {
    const intl = useIntl();

    const gradient = useMemo(() => (
        <div className={"w-full h-full"}
             style={{
                 background: "linear-gradient(180deg, rgba(68, 26, 152, 0.16) 0%, rgba(134, 226, 188, 0.28) 90%)",
                 filter: "blur(150px)"
             }} />
    ), [])

    return (
        <PageWrapper className={"mt-[88px]"}>
            <div className={"relative w-[489px] aspect-[489/578]"}>
                <div className={"w-[734px] h-[683px] absolute top-[-449px] left-[-413px] rotate-[40.9deg]"}>
                    {gradient}
                </div>
                <div className={"absolute left-0 top-0 rounded-[8px] border border-[#FFFFFF] p-[10px] z-10 w-[77%] h-[44%]"}>
                    <img src={KoFAQConsole} alt="FAQ Console" className={"rounded-[8px]"} />
                </div>
                <div className="absolute right-0 bottom-0 z-10 w-[82%] h-[78%]">
                    <img src={FAQCloseupShadow} alt="closeup shadow" />
                </div>
                <div className={"absolute right-[8px] bottom-[8px] z-10 w-[66%] h-[75%]"}>
                    <img src={KoFAQSetting} alt="FAQ Setting" className={"rounded-[8px] shadow-[0px_54px_46px_-22px_rgba(110,102,126,0.38)]"} />
                </div>
            </div>
            <div className={"max-w-[550px] z-10"}>
                <Page.Heading>
                    {intl.formatMessage({id: "i0027"})}
                </Page.Heading>
                <Page.Description className={"mt-[16px]"}>
                    {intl.formatMessage({id: "i0028"})}
                </Page.Description>
                <Page.CheckList className={"mt-[40px]"}>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0029"})}
                    </Page.CheckListItem>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0030"})}
                    </Page.CheckListItem>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0031"})}
                    </Page.CheckListItem>
                </Page.CheckList>
            </div>
        </PageWrapper>
    )
}

export default FAQInfoPage;
